// User-facing translations for project pages (public viewer, AR launchers, WebXR viewer).
// Admin panel is intentionally NOT translated and stays in Polish.
// Default language is always "pl". To add a new language (e.g. "de"), add a new key below.

export const translations = {
  pl: {
    // common
    close: "Zamknij",
    cancel: "Anuluj",
    tryAgain: "Spróbuj ponownie",
    copyLink: "Skopiuj link",
    copied: "Skopiowano!",
    linkCopied: "Link skopiowany",
    generatingQr: "Generowanie QR...",
    loading: "Ładowanie...",

    // public viewer
    loadingPreview: "Ładowanie podglądu...",
    loadingHint: "Ładowanie modelu może potrwać chwilę przy wolniejszym połączeniu.",
    projectNotFound: "Projekt nie został znaleziony.",
    projectNotFoundShort: "Nie znaleziono projektu",
    missingGlb: "Brak pliku GLB dla tego projektu.",
    modelLoadError: "Nie udało się wczytać modelu na tym urządzeniu",
    refreshPage: "Odśwież stronę",
    defaultDescription: "Podgląd modelu 3D",
    viewInArWithSound: "Zobacz w AR z dźwiękiem",
    viewInAr: "Zobacz w AR",
    iosNeedsUsdz: "AR na iPhone wymaga pliku USDZ.",
    pressViewInAr: "Naciśnij „Zobacz w AR”, żeby zobaczyć model w swoim otoczeniu.",
    resumeSound: "Wznów dźwięk",

    // QR modal
    scanQrTitle: "Zeskanuj kod QR",
    seeModelInSpace: "Zobacz model w swoim otoczeniu",
    qrStep1: "Zeskanuj kod QR aparatem w telefonie.",
    qrStep2: "Otwórz link, który pojawi się na ekranie.",
    qrStep3: "Kliknij „Zobacz w AR\".",
    qrStep4: "Skieruj telefon na podłogę i ustaw model w swoim otoczeniu.",
    qrFootnote:
      "Użyj wbudowanego aparatu w telefonie — nie instaluj zewnętrznych aplikacji do skanowania kodów QR.",

    // AR modals
    arBestChrome: "AR najlepiej działa w Chrome",
    arBestChromeText:
      "Na tym telefonie AR może nie uruchomić się w tej przeglądarce. Otwórz link w Google Chrome i spróbuj ponownie.",
    openInChrome: "Otwórz w Google Chrome",
    closeStay3d: "Zamknij / Zostań w 3D",
    arFailed: "Nie udało się uruchomić AR na tym urządzeniu.",
    installUpdate: "Zainstaluj/aktualizuj",
    viewInRealityTitle: "Zobacz w rozszerzonej rzeczywistości",
    tapToLaunchCamera: "Kliknij przycisk poniżej, aby uruchomić kamerę AR",

    // toasts
    soundToast: "Dźwięk uruchomi się po kliknięciu „Zobacz w AR z dźwiękiem”.",
    soundFailed: "Nie udało się uruchomić dźwięku.",
    copyFailed: "Nie udało się skopiować linku. Skopiuj ręcznie.",
    openInChromeFailed: "Nie udało się otworzyć w Chrome",
    arLinkCopied: "Skopiowano link do AR",

    // launch-ar / launch pages
    projectNoModel: "Projekt nie zawiera modelu 3D",
    noUsdzIos: "Brak pliku USDZ dla iOS",
    projectLoadFailed: "Nie udało się wczytać projektu",
    launchingAr: "Uruchamiam AR...",
    openProjectFailed: "Nie udało się otworzyć projektu",
    open3dPreview: "Otwórz podgląd 3D",
    useStandardAr: "Użyj standardowego AR",
    loadingProject: "Ładowanie projektu...",
    error: "Błąd",
    noModel3d: "Nie znaleziono modelu 3D",
    invalidModelUrl: "Nieprawidłowy URL modelu 3D",
    arLaunchFailed: "Nie udało się uruchomić AR",
    loadingArModel: "Ładowanie modelu AR...",

    // WebXR viewer
    arInBrowser: "Tryb AR w przeglądarce",
    pointCameraFloor: "Skieruj kamerę na podłogę",
    tapWhenGreen: "Dotknij, gdy zobaczysz zielony znacznik",
    launchAr: "Uruchom AR",
    launching: "Uruchamiam...",
    useStandardArMode: "Użyj standardowego trybu AR",
    arLaunchFailedTitle: "Nie udało się uruchomić AR",
    arLaunchFailedSub: "Spróbuj ponownie lub użyj standardowego AR",
    runStandardAr: "Uruchom standardowe AR",
    backTo3d: "Wróć do podglądu 3D",
    modelLoadErrorTitle: "Błąd ładowania modelu",
    modelLoadErrorSub: "Nie udało się wczytać modelu 3D",
    finish: "Zakończ",
    placeAgain: "Ustaw ponownie",
    arTakePhoto: "Zrób zdjęcie",
    arPhotoTitle: "Zdjęcie AR",
    arPhotoSave: "Zapisz",
    arPhotoShare: "Udostępnij",
    arPhotoClose: "Zamknij",
    loadingModel: "Ładowanie modelu...",
    searchingSurface: "Szukam powierzchni...",
    cantDetectFloor: "Nie mogę wykryć podłogi",
    tryBetterLight: "Spróbuj w lepiej oświetlonym miejscu",
    stabilizing: "Stabilizuję pozycję...",
    tapToPlace: "Dotknij, aby postawić model",
    modelPlaced: "Model postawiony",
    modelLoadFailedPrefix: "Nie udało się wczytać modelu",
    webglLost: "Utracono kontekst WebGL",
    fileNotFound: "Plik nie znaleziony (404)",
    corsError: "Błąd CORS",
    containerUnavailable: "Kontener niedostępny",

    model3d: "Model 3D",
  },

  en: {
    // common
    close: "Close",
    cancel: "Cancel",
    tryAgain: "Try again",
    copyLink: "Copy link",
    copied: "Copied!",
    linkCopied: "Link copied",
    generatingQr: "Generating QR...",
    loading: "Loading...",

    // public viewer
    loadingPreview: "Loading preview...",
    loadingHint: "Loading the model may take a moment on a slower connection.",
    projectNotFound: "Project not found.",
    projectNotFoundShort: "Project not found",
    missingGlb: "No GLB file for this project.",
    modelLoadError: "Could not load the model on this device",
    refreshPage: "Refresh page",
    defaultDescription: "3D model preview",
    viewInArWithSound: "View in AR with sound",
    viewInAr: "View in AR",
    iosNeedsUsdz: "AR on iPhone requires a USDZ file.",
    pressViewInAr: "Press “View in AR” to see the model in your space.",
    resumeSound: "Resume sound",

    // QR modal
    scanQrTitle: "Scan the QR code",
    seeModelInSpace: "See the model in your space",
    qrStep1: "Scan the QR code with your phone camera.",
    qrStep2: "Open the link that appears on screen.",
    qrStep3: "Tap “View in AR”.",
    qrStep4: "Point your phone at the floor and place the model in your space.",
    qrFootnote:
      "Use your phone’s built-in camera — no need to install any third-party QR scanner apps.",

    // AR modals
    arBestChrome: "AR works best in Chrome",
    arBestChromeText:
      "AR may not launch in this browser on this phone. Open the link in Google Chrome and try again.",
    openInChrome: "Open in Google Chrome",
    closeStay3d: "Close / Stay in 3D",
    arFailed: "Could not launch AR on this device.",
    installUpdate: "Install/Update",
    viewInRealityTitle: "View in augmented reality",
    tapToLaunchCamera: "Tap the button below to launch the AR camera",

    // toasts
    soundToast: "Sound will start after you tap “View in AR with sound”.",
    soundFailed: "Could not start the sound.",
    copyFailed: "Could not copy the link. Please copy it manually.",
    openInChromeFailed: "Could not open in Chrome",
    arLinkCopied: "AR link copied",

    // launch-ar / launch pages
    projectNoModel: "Project has no 3D model",
    noUsdzIos: "No USDZ file for iOS",
    projectLoadFailed: "Could not load the project",
    launchingAr: "Launching AR...",
    openProjectFailed: "Could not open the project",
    open3dPreview: "Open 3D preview",
    useStandardAr: "Use standard AR",
    loadingProject: "Loading project...",
    error: "Error",
    noModel3d: "No 3D model found",
    invalidModelUrl: "Invalid 3D model URL",
    arLaunchFailed: "Could not launch AR",
    loadingArModel: "Loading AR model...",

    // WebXR viewer
    arInBrowser: "AR mode in your browser",
    pointCameraFloor: "Point the camera at the floor",
    tapWhenGreen: "Tap when you see the green marker",
    launchAr: "Launch AR",
    launching: "Launching...",
    useStandardArMode: "Use standard AR mode",
    arLaunchFailedTitle: "Could not launch AR",
    arLaunchFailedSub: "Try again or use standard AR",
    runStandardAr: "Launch standard AR",
    backTo3d: "Back to 3D preview",
    modelLoadErrorTitle: "Model loading error",
    modelLoadErrorSub: "Could not load the 3D model",
    finish: "Finish",
    placeAgain: "Place again",
    arTakePhoto: "Take photo",
    arPhotoTitle: "AR photo",
    arPhotoSave: "Save",
    arPhotoShare: "Share",
    arPhotoClose: "Close",
    loadingModel: "Loading model...",
    searchingSurface: "Searching for a surface...",
    cantDetectFloor: "Can't detect the floor",
    tryBetterLight: "Try a better-lit area",
    stabilizing: "Stabilizing position...",
    tapToPlace: "Tap to place the model",
    modelPlaced: "Model placed",
    modelLoadFailedPrefix: "Could not load the model",
    webglLost: "WebGL context lost",
    fileNotFound: "File not found (404)",
    corsError: "CORS error",
    containerUnavailable: "Container unavailable",

    model3d: "3D Model",
  },
};

export const getT = (lang) => translations[lang] || translations.pl;
